import { Fragment } from "react";
import { useParams } from "react-router-dom";
import { Grid, SvgIcon, Typography } from "@mui/material";
import * as L from "leaflet";
import { useTranslation } from "react-i18next";

import { Pane } from "src/components/Pane";
import { PaneListButton } from "src/components/PaneListButton";
import { ReactComponent as RegularGridIcon } from "src/assets/icons/regular-grid.svg";
import { ReactComponent as LineBasedGridIcon } from "src/assets/icons/line-based-grid.svg";
import { ReactComponent as PointBasedGridIcon } from "src/assets/icons/point-based-grid.svg";

interface Props {
  map: L.Map | null; // the map is great to have, but not visualizing RegularGrid should still render the page
}
export function GridSettingsPage(props: Props) {
  const { t } = useTranslation();
  const params = useParams<{ caseId: string }>();

  return render();

  function render() {
    return (
      <Fragment>
        <Pane>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h2">{t("label.gridSettings")}</Typography>
            </Grid>
            <Grid item xs={12}>
              <PaneListButton to={`/cases/${params.caseId}/grid-settings/regular-grid`}>
                <SvgIcon component={RegularGridIcon} viewBox="0 0 22 22" />
                {t("label.regularGrid")}
              </PaneListButton>
            </Grid>
            <Grid item xs={12}>
              <PaneListButton to={`/cases/${params.caseId}/grid-settings/line-based-grid`}>
                <SvgIcon component={LineBasedGridIcon} viewBox="0 0 22 17.6" />
                {t("label.lineBasedGrid")}
              </PaneListButton>
            </Grid>
            <Grid item xs={12}>
              <PaneListButton to={`/cases/${params.caseId}/grid-settings/point-based-grid`}>
                <SvgIcon component={PointBasedGridIcon} viewBox="0 0 12.375 22" />
                {t("label.pointBasedGrid")}
              </PaneListButton>
            </Grid>
          </Grid>
        </Pane>
      </Fragment>
    );
  }
}
